import React, { useEffect, useState } from 'react'
import { Box, Button, Divider, Grid, styled, Switch } from '@mui/material'
import DefaultPainel from '../../components/shared/Painel'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import TableHeader from '../../components/shared/tables/TableHeader'
import { Leitores } from '../../services/http'
import SmallTextField from '../../components/textfield/SmallTextfield'
import PrivateRC from '../../components/PrivateRC'
import gerarPaginacao from '../../services/pagination'
import BaseFilter from '../../components/BaseFilter'
import BasicDatagrid from '../../components/shared/tables/BasicDatagrid'
import SearchEndAdornment from '../../components/adornment/SearchEndAdornment'
import SearchStartAdornment from '../../components/adornment/SearchStartAdornment'
import MobileFilterHeaderContainer from '../../components/filters/MobileFilterHeaderContainer'
import { CloudSyncTwoTone } from '@mui/icons-material'
import ModalSincronizar from './components/ModalSincronizar'
import { notification } from '../../services/notification'

const filters = [
  {
    service: {
      folder: 'bibliotecas',
      file: 'Bibliotecas',
      relationship: ''
    },
    listLabel: 'biblioteca',
    label: 'Biblioteca',
    itemValue: 'id',
    itemText: 'apelido',
    id: 'includes[biblioteca][id]'
  }
]

const LectorsTable = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '76vh'
  },
  '& .MuiDataGrid-cell': {
    textAlign: 'start',
    '&:nth-of-type(4)': {
      textAlign: 'center!important'
    },
    '&:nth-of-type(5)': {
      textAlign: 'center!important'
    },
    '&:nth-of-type(6)': {
      textAlign: 'center!important'
    }
  }
}))

const Leitor = () => {
  const [rows, setRows] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [queryLector, setQueryLector] = useState([])
  const [query, setQuery] = useState({})
  const [lastPage, setLastPage] = useState(1)
  const [tloading, setTloading] = useState(false)
  const [modalSincronizar, setModalSincronizar] = useState(false)

  const handleToggleExibeRelatorio = async (leitorId, currentValue) => {
    try {
      await Leitores(leitorId).update({
        exibe_relatorio: !currentValue
      })

      notification('Configuração atualizada com sucesso!', 'success')

      // Atualizar a tabela localmente
      setRows(prevRows =>
        prevRows.map(row =>
          row.id === leitorId ? { ...row, exibe_relatorio: !currentValue } : row
        )
      )
    } catch (error) {
      notification('Erro ao atualizar configuração', 'error')
      console.error('Erro ao atualizar exibe_relatorio:', error)
    }
  }

  const columns = [
    {
      field: 'biblioteca',
      headerName: 'Biblioteca',
      flex: 1
    },
    {
      field: 'leitor',
      headerName: 'Leitor',
      flex: 3
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 3
    },
    {
      field: 'codLeitor',
      headerName: 'Cód. Leitor',
      flex: 1
    },
    {
      field: 'codUser',
      headerName: 'Cód. Usuário',
      flex: 1
    },
    {
      field: 'exibe_relatorio',
      headerName: 'Exibir no Relatório',
      flex: 1,
      renderCell: params => (
        <PrivateRC roles="gestor">
          <Switch
            checked={params.row.exibe_relatorio || false}
            onChange={() =>
              handleToggleExibeRelatorio(
                params.row.id,
                params.row.exibe_relatorio
              )
            }
            color="primary"
          />
        </PrivateRC>
      )
    }
  ].map(item => ({ ...item, headerClassName: 'jaostyle', sortable: false }))

  const getLeitores = async (filters = {}, page) => {
    setTloading(true)
    const { data } = await Leitores().show({
      'includes[]': 'user,biblioteca',
      'includes[user][ativo]': true,
      page,
      ...filters
    })
    setCurrentPage(data.current_page)
    setLastPage(data.last_page)
    const aux = data.data.map(item => ({
      ...item,
      leitor: item.user.name,
      email: item.user.email,
      biblioteca: item.biblioteca.apelido,
      codLeitor: item.id,
      codUser: item.user.id,
      exibe_relatorio: item.exibe_relatorio ?? true
    }))
    setRows(aux)
    setTloading(false)
  }

  const init = async () => {
    getLeitores()
    setRows([])
  }

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => getLeitores(query, value)
  )

  let typingTimer = ''

  const getLector = () => {
    setQuery(
      Object.assign(query, {
        'includes[user][name]': `%${queryLector?.toUpperCase()}%`
      })
    )
    getLeitores(query)
  }

  const handleClean = () => {
    if (queryLector !== '') {
      setQueryLector('')
      delete query['includes[user][name]']
      getLeitores({ ...query, 'includes[user][name]': undefined })
    }
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <Box>
      <DefaultPainel sx={{ mt: '4vh' }}>
        <AdaptativeGridContainer>
          <>
            <TableHeader
              titulo="Leitores"
              controls={
                <MobileFilterHeaderContainer>
                  <PrivateRC roles="bibliotecario">
                    <SmallTextField
                      sx={{ marginRight: '15px' }}
                      type="text"
                      placeholder="Leitor"
                      variant="standard"
                      color="white"
                      onKeyDown={() => {
                        clearTimeout(typingTimer)
                      }}
                      onKeyUp={() => {
                        clearTimeout(typingTimer)
                        typingTimer = setTimeout(getLector, 1000)
                      }}
                      onChange={({ target }) => {
                        setQueryLector(target.value)
                      }}
                      value={queryLector}
                      InputProps={{
                        style: {
                          color: 'white'
                        },
                        startAdornment: <SearchStartAdornment />,
                        endAdornment: (
                          <SearchEndAdornment action={handleClean} />
                        )
                      }}
                    />
                  </PrivateRC>
                  <PrivateRC roles="gestor">
                    <ModalSincronizar
                      status={modalSincronizar}
                      setStatus={setModalSincronizar}
                    ></ModalSincronizar>
                  </PrivateRC>
                  <BaseFilter
                    filter={filters}
                    color="white"
                    onChange={value => {
                      setQuery(Object.assign(query, value))
                      getLeitores(query)
                    }}
                  />
                </MobileFilterHeaderContainer>
              }
            />

            <Grid item xs={12} sm={12}>
              <Divider />
              <LectorsTable
                rows={rows}
                columns={columns}
                disableColumnMenu
                pagination={pagination}
                loading={tloading}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </Box>
  )
}

export default Leitor
